import {
  clearUserTokenCookies,
  getUserAccessTokenCookie,
  getUserFromCookie,
  getUserRefreshTokenCookie,
} from 'commons/localStorage';
import { logError } from 'commons/logger';

const hasSessionCookies = () =>
  Boolean(
    getUserFromCookie() ||
      getUserAccessTokenCookie() ||
      getUserRefreshTokenCookie()
  );

// Ends the session in this tab and drops the user's data from the Apollo cache
// (CON-8904)
const logoutClientSession = ({
  client,
  hadUser = false,
  reloadsPage = false,
  resetUserData,
}) => {
  const hadSessionCookies = hasSessionCookies();

  resetUserData();
  clearUserTokenCookies();

  // Pages call logout on every render while logged out, so a session only ends
  // once: when the user was signed in, or its cookies are now gone. Cookies
  // that can't be removed must not reset the cache on every call.
  const endedSession = hadUser || (hadSessionCookies && !hasSessionCookies());

  // A page reload clears the cache anyway
  if (!endedSession || !client || reloadsPage) {
    return;
  }

  // Not resetStore or clearStore: they reject in-flight queries, which crashes
  // pages with loading suspense queries. Not every mounted query refetches
  // after a cache reset, so they are refetched explicitly.
  client.cache
    .reset()
    .then(() => client.reFetchObservableQueries())
    .catch(err => {
      logError(err, 'Failed to reset Apollo cache on logout');
    });
};

export default logoutClientSession;
